<template>
  <div id="ShareButtons">
    <h5>Share page on</h5>
    <ul class="share-buttons">
      <li class="share-button--facebook">
        <a href="javascript:void(0)" @click="shareFacebook()">
          <FacebookIcon/>
        </a>
      </li>
      <li class="share-button--twitter">
        <a href="javascript:void(0)" @click="shareTwitter()">
          <TwitterIcon/>
        </a>
      </li>
      <li class="share-button--google">
        <a href="javascript:void(0)" @click="shareGoogle()">
          <GooglePlusIcon/>
        </a>
      </li>
      <li class="share-button--linkedin">
        <a href="javascript:void(0)" @click="shareLinkedIn()">
          <LinkedinIcon/>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import FacebookIcon from '../assets/social-facebook.svg'
import TwitterIcon from '../assets/social-twitter.svg'
import GooglePlusIcon from '../assets/social-google-plus.svg'
import LinkedinIcon from '../assets/social-linkedin.svg'

export default {
  name: 'ShareButtons',
  components: {
    FacebookIcon,
    TwitterIcon,
    GooglePlusIcon,
    LinkedinIcon
  },
  methods: {
    shareTwitter () {
      window.open(`https://twitter.com/intent/tweet?url=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=550,height=420')
    },
    shareFacebook () {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=626,height=436')
    },
    shareLinkedIn () {
      window.open(`https://www.linkedin.com/shareArticle?url=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=520,height=570')
    },
    shareGoogle () {
      window.open(`https://plus.google.com/share?url=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
#ShareButtons {
  padding: 36px;

  .share-buttons {
    list-style: none;
    padding: 0;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    > li {
      a {
        transition: .2s background;
        display: flex;
        width: 56px;
        height: 56px;
        background: #b2b2b2;
        border-radius: 5px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        justify-content: center;
      }

      svg {
        width: 70%;
        fill: $white;
      }
      &.share-button--facebook {
        svg {
          height: 100%;
        }
        &:hover a { background: $brand-facebook; }
      }
      &.share-button--twitter:hover {
        a { background: $brand-twitter; }
      }
      &.share-button--linkedin:hover {
        a { background: $brand-linkedin; }
      }
      &.share-button--google:hover {
        a { background: $brand-google; }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareButtons.vue